module.exports = __webpack_public_path__ + "assets/images/tutorial8.649ecee.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/tutorial/tutorial8.png
// module id = 459
// module chunks = 1